/* eslint-disable func-names */
/* eslint-disable object-shorthand */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './index.scss';

import AgGridReactComponent from '../../../../common/components/ag-grid-react-component';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';
import { formatGivenDate } from '../../../../shared/services/common-functions';

function onGridReady(params) {
    setTimeout(() => {
        params.api.sizeColumnsToFit();
    }, 500);
}

const BundleRunningAvailabilityTable = props => {

    const colDefs = [];

    colDefs.push(
        {
            field: 'family',
            headerName: 'Family',
            sortable: true,
            filter: true,
            pinned: 'left',
            width: 140
        }
    );
    colDefs.push(
        {
            field: 'orderingCode',
            headerName: 'Bundle',
            sortable: true,
            filter: true,
            width: 120,
            pinned: 'left',
            cellRenderer: params => {

                if ( params.value === 0 ) return ( <span>{params.value}</span> );
                return ( <Link to={`/${params.data.unitName}/order/availability?constrainttype=BN&constraintkey=${params.value}`}>{params.value}</Link> );

            }
        }
    );

    props.lastWeeks.forEach( weekObj => {

        const weekEnding = formatGivenDate( weekObj.weekEnding, 'YYYY-MM-DD' );
        const selectedWeekEnding = formatGivenDate( Number( props.selectedLastWeek ), 'YYYY-MM-DD' );

        if ( weekEnding === selectedWeekEnding ||
            new Date( weekEnding ) < new Date( selectedWeekEnding ) ) {

            const dateVal = weekObj.weekEnding;
            let headerName = `${formatGivenDate( Number( dateVal ), 'DDMMMYY' )}(${weekObj.monthNumber})`.toUpperCase();
            const dateField = formatGivenDate( Number( dateVal ), 'YYYY-MM-DD' );

            if ( dateField === '2000-01-01' ) {

                headerName = 'Inventory';

            } else if ( dateField === '2000-02-01' ) {

                headerName = 'Rework';

            }
            colDefs.push(
                {

                    field: `${Number( dateVal )}`,
                    headerName: `${headerName}`,
                    sortable: true,
                    filter: true,
                    width: 125

                }
            );

        }

    } );

    const tableResult = [];
    props.results.forEach( tempResult => {

        const nestedTableResult = {};
        nestedTableResult.family = tempResult.family;

        nestedTableResult.orderingCode = tempResult.orderingCode;

        Object.keys( tempResult.runningAvailibilityDetails ).forEach( item => {

            nestedTableResult[item] = tempResult.runningAvailibilityDetails[item].totalRunning;

        } );
        tableResult.push( nestedTableResult );

    } );

    const additionalInfo = { unitName: props.unitCode };
    const bundleRunningAvailabilityResult = tableResult.map( i => ( { ...i, ...additionalInfo } ) );

    return (

        <section className="atp-search-result-panel bundle-running-availability-result-panel ">

            <div className="results-message">
                {`Record Count is ${props.totalRows}.`}
            </div>

            <div className="atp-ag-grid ag-theme-balham ag-theme-popupbg">
                <AgGridReactComponent
                    reactNext={true}
                    columnDefs={colDefs}
                    rowData={bundleRunningAvailabilityResult}
                    onGridReady={onGridReady}
                />
            </div>

        </section>
    );

};

BundleRunningAvailabilityTable.propTypes = {
    results: PropTypes.array.isRequired,
    totalRows: PropTypes.number,
    unitCode: PropTypes.string.isRequired,
    selectedLastWeek: PropTypes.string.isRequired,
    lastWeeks: PropTypes.array.isRequired
};
export default BundleRunningAvailabilityTable;
